import { css } from "@emotion/css";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, ExternalLink, TextField } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { useState } from "react";
import { repository } from "~/clientInstance";
export interface GitHubAccessCodeModalProps {
    isOpen: boolean;
    onClose: () => void;
}
const styles = {
    linkContainer: css({ marginBottom: space[16] }),
};
export function GitHubAccessCodeModal({ isOpen, onClose }: GitHubAccessCodeModalProps) {
    const [accessCode, setAccessCode] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const handleClose = () => {
        setAccessCode("");
        setErrorMessage("");
        onClose();
    };
    const handleSubmit = async () => {
        if (!accessCode.trim())
            return;
        setErrorMessage("");
        setIsSubmitting(true);
        const result = await repository.GitHubApp.exchangeAccessCodeForToken(accessCode.trim());
        if (result.Status === "Error") {
            setIsSubmitting(false);
            setErrorMessage(result.ErrorMessage);
        }
        else {
            window.location.reload();
        }
    };
    return (<Dialog open={isOpen} dialogWidth="600px">
            <DialogTitle>Enter access code</DialogTitle>
            <DialogContent>
                <div>Enter the access code to complete GitHub authorization:</div>
                <div className={styles.linkContainer}>
                    <ExternalLink href={"#"}>Learn More</ExternalLink>
                </div>
                <TextField label="Access Code" value={accessCode} onChange={setAccessCode} autoFocus type={"password"} error={errorMessage}/>
            </DialogContent>
            <DialogActions>
                <Button label="Cancel" onClick={handleClose} importance="quiet" disabled={isSubmitting}/>
                <Button label={isSubmitting ? "Submitting..." : "Submit"} onClick={handleSubmit} importance="loud" disabled={!accessCode.trim() || isSubmitting}/>
            </DialogActions>
        </Dialog>);
}
